@use '@design/design-tokens/typography/typography' as *;

[data-testid='tab-lines'].tabLines {
  background-color: var(--background-soft);
  [data-tab-header] {
    padding-left: 20px;
  }

  [data-tab] {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  [data-tab-button] {
    white-space: nowrap;
    @include typography-v2-ui-sm;
    padding: 8px 4px;
  }
}

.entityPriceWrapperUniversal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 8px 20px;
  background-color: var(--background-default);
}

.emptyContainer {
  min-height: 80vh;
  display: flex;
}

.emptyWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  justify-content: center;
}

.emptyTitle {
  @include typography-v2-title-lg;
}

.emptyImage {
  width: 146px;
  height: auto;
}


.root {
  margin-bottom: 12px;

  [data-tab-header] {
    padding-left: 20px;
  }
}